const Gtm = {
  push,
  pushAsync,
}
export default Gtm

declare global {
  interface Window {
    dataLayer?: object[]
  }
}

function push(data: object) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(data)
}

/**
 * Pushes data to the dataLayer and returns a promise that resolves after
 * GTM processes the event. Uses GTM's eventCallback mechanism with a timeout
 * fallback to ensure the promise always resolves.
 *
 * @param data - The data to push to the dataLayer
 * @param timeoutMs - Maximum time to wait if callback isn't called (default: 2000ms)
 * @returns A promise that resolves when GTM calls the callback or timeout occurs
 */
function pushAsync(data: object, timeoutMs: number = 2000): Promise<void> {
  return new Promise((resolve) => {
    let resolved = false

    // Safety timeout in case GTM doesn't call the callback
    const timeout = setTimeout(() => {
      if (!resolved) {
        resolved = true
        resolve()
      }
    }, timeoutMs)

    // Push event with GTM's eventCallback
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      ...data,
      eventCallback: () => {
        if (!resolved) {
          resolved = true
          clearTimeout(timeout)
          resolve()
        }
      },
      eventTimeout: timeoutMs,
    })
  })
}
